import { useEffect, useRef } from "react";

function FriendlyCaptchaWidget({ onSolved }) {
  const captchaRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://unpkg.com/friendly-challenge@0.9.9/widget.min.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Callback globale
    window.onCaptchaSolved = (solution) => {
      if (solution) {
        onSolved(solution);
      } else {
        console.error("Captcha non résolu correctement");
      }
    };

    return () => {
      window.onCaptchaSolved = null;
    };
  }, []);

  return (
    <div
      ref={captchaRef}
      className="frc-captcha"
      data-sitekey="site_x2Vd8LkYzP7tMa9QeRfWbCsJh0NuG1Zo"
      data-puzzle-endpoint="https://www.friendlycaptcha.cloud.geoprod.com/puzzle.php"
      data-callback="onCaptchaSolved"
      data-lang="fr"
    />
  );
}

export default FriendlyCaptchaWidget;
